import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import ReportDialog from "./ReportDialog";
import SentryContext from "./Context";
import useFeedbackController from "./useFeedbackController";

const Provider = ({
  children,
  hub,
  logger,
  container,
  friendlyProjectName
}) => {
  const [shownReportDialog, reportDialogOptions, closeReportDialog, showReportDialog, submitFeedback] = useFeedbackController({
    hub,
    logger,
    friendlyProjectName
  });
  const ContextValue = React.useMemo(() => ({
    showReportDialog,
    closeReportDialog
  }), [showReportDialog, closeReportDialog]);
  const reportDialog = /*#__PURE__*/React.createElement(ReportDialog, {
    options: reportDialogOptions,
    onClose: closeReportDialog,
    onSubmit: submitFeedback
  });
  return /*#__PURE__*/React.createElement(SentryContext.Provider, {
    value: ContextValue
  }, children, shownReportDialog ? ReactDOM.createPortal(reportDialog, container) : null);
};

Provider.defaultProps = {
  logger: console,
  container: document.body,
  friendlyProjectName: document.title
};
Provider.propTypes = {
  hub: PropTypes.object.isRequired,
  children: PropTypes.node,
  container: PropTypes.instanceOf(HTMLElement),
  logger: PropTypes.shape({
    log: PropTypes.func,
    info: PropTypes.func,
    warn: PropTypes.func,
    error: PropTypes.func
  }),
  friendlyProjectName: PropTypes.string
};
export default Provider;